import { Plus, Minus } from "lucide-react";
import { useState } from "react";

export default function Permissions({ permissions, label, name, setName }) {
    const [open, setOpen] = useState(false);

    const togglePermission = (key) => {
        setName(prev => {
            const safePrev = typeof prev === "object" && prev !== null ? prev : {};

            // If key is already "on", remove it (uncheck)
            if (safePrev[key] === "on") {
                const { [key]: _, ...rest } = safePrev; // remove the key
                return rest;
            }

            // Otherwise, add key with value "on"
            return { ...safePrev, [key]: "on" };
        });
    };

    return (
        <div className="border rounded-xl p-4 bg-white shadow-sm">
            <div
                className="flex items-center justify-between cursor-pointer"
                onClick={() => setOpen(!open)}
            >
                <legend className="text-lg font-semibold text-slate-800">
                    {label} permissions
                </legend>

                {open ? (
                    <Minus className="w-5 h-5 text-slate-600" />
                ) : (
                    <Plus className="w-5 h-5 text-slate-600" />
                )}
            </div>

            {/* Collapsible Section */}
            <div
                className={`grid grid-cols-3 gap-4 mt-4 transition-all duration-300 overflow-hidden ${open ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                    }`}
            >
                {Object.keys(permissions).map((key, i) => {
                    const feature = key.replace("vcom_", "");

                    return (
                        <label
                            key={i}
                            className="flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                className="h-4 w-4 accent-purple-600 border-2 border-purple-500"
                                name={name}
                                checked={!!name[key]}
                                onChange={() => togglePermission(key)}
                            />
                            <span className="text-gray-700 capitalize">{feature}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}